import { ApiAccounts, ApiAccountsFormData } from '../types';

import { convertFlagsArrayToObjects } from 'utils/misc';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';

import { useGetApiAccountById } from '../../../../../queries';
import { EditOrCreateForm } from './EditOrCreateForm';

interface Props {
  showAPIKey: (apiKey: string) => void;
  isOpenForGenerating: boolean;
}

const convertToFormData = (data: ApiAccounts): ApiAccountsFormData => {
  return { ...data, flags: convertFlagsArrayToObjects(data.flags) };
};

export const EditOrCreate = ({
  rowId,
  handleClose,
  ...props
}: FormComponentProps & Props) => {
  const { isFetching, data } = useGetApiAccountById(rowId);

  if (isFetching) {
    return <DrawerFormSkeleton count={3} />;
  }

  return (
    <EditOrCreateForm
      isOpenForGenerating={props.isOpenForGenerating}
      showAPIKey={props.showAPIKey}
      formData={rowId ? convertToFormData(data) : data}
      handleClose={handleClose}
    />
  );
};
